import { useEffect } from "react";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import { ThemeProvider } from "@/context/ThemeContext";
import Navbar from "@/components/editorial/Navbar";
import FloatingNav from "@/components/editorial/FloatingNav";
import CelestialToggle from "@/components/editorial/CelestialToggle";
import BackToTop from "@/components/editorial/BackToTop";
import SplashCursor from "@/components/editorial/SplashCursor";
import Hero from "@/components/editorial/Hero";
import Background from "@/components/editorial/Background";
import Timeline from "@/components/editorial/Timeline";
import Studies from "@/components/editorial/Studies";
import Experience from "@/components/editorial/Experience";
import Products from "@/components/editorial/Products";
import Toolkit from "@/components/editorial/Toolkit";
import Contact from "@/components/editorial/Contact";
import Footer from "@/components/editorial/Footer";
import SmoothScrollProvider from "@/components/SmoothScrollProvider";
import LoadingScreen from "@/components/LoadingScreen";



const API = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ? `${process.env.REACT_APP_BACKEND_URL || "http://localhost:8000"}/api`
  : "/api";

const Home = () => {
  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
  }, []);

  return (
    <div className="App paper-grain" data-testid="app-root">
      <LoadingScreen />
      <SmoothScrollProvider />
      <SplashCursor />
      <main className="relative">
        <CelestialToggle />
        <FloatingNav />
        <BackToTop />
        <Hero />
        <Background />
        <Timeline />
        <Studies />
        <Experience />
        <Products />
        <Toolkit />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
